import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// image
//import logo from "../../images/logo-full.png";
import logo from "../../images/logo.png";
//import { ThemeContext } from "../context/ThemeContext";

const LockScreen = ({ history }) => {
  const navigate = useNavigate();	
  const [loading, setLoading] = useState(false);
  const submitHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      navigate("/dashboard");
      setLoading(false);
    }, 1000);
  };
  return (
    <div className="authincation ">
      <div className="container">
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-6">
            <div className="authincation-content">
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div className="auth-form">
                    <div className=" mb-3">
                      {/* <Link to="/dashboard">
                        <img src={logo} alt="" />
                      </Link>
                      <h3 className="mb-0 font-w600">Workload</h3> */}
                      <Link to="/dashboard" className="brand-logo d-flex align-items-center justify-content-center">
                        <img src={logo} alt="" />
                        <div className="brand-title ms-3">
                          <h2 className="mb-0 font-w600">Workload</h2>
                          <span className="brand-sub-title">Project Management Admin</span>
                        </div>
                      </Link>
                    </div>
                    <h4 className="text-center mb-4 ">Account Locked</h4>
                    <form onSubmit={(e) => submitHandler(e)}>
                      <div className="form-group mb-3">
                        <label className="">
                          <strong>Password</strong>
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          defaultValue="Password"
                        />
                      </div>
                      <div className="text-center">
                        <button
                          type="submit"
                          className="btn btn-primary btn-block"
                          disabled={loading}
                        >
                          {loading ? (
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          ) : null}
                          Unlock
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LockScreen;
